import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client"; 
import { performGlobalLogout } from './authSlice';

export const fetchOpenBets = createAsyncThunk(
  "openBets/fetchOpenBets",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/bets/open-bets/${userId}`);
      return res.data;
    } catch (err) {
      console.error("Error fetching open bets:", err);
      return rejectWithValue(err.response?.data || { message: "Failed to fetch open bets" });
    }
  }
);

const betHistorySlice = createSlice({
  name: "openBets",
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {
    resetOpenBets: (state) => {
      state.data = [];
      state.loading = false;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOpenBets.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOpenBets.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOpenBets.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching open bets";
      })
      // GLOBAL LOGOUT
      .addCase(performGlobalLogout.fulfilled, (state) => {
        state.data = [];
        state.loading = false;
        state.error = null;
      });
  },
});

export const { resetOpenBets } = betHistorySlice.actions;
export default betHistorySlice.reducer;
